import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/amenityType'

export const amenityTypeService = {
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    search,
};

//index
function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

//getAll
function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

//show
function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

//search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert: false })
}


//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}